import { useEffect, useState } from 'react';

import { useAuth0 } from '@auth0/auth0-react';

import { setSentryAndAnalyticsAfterLogin } from './login.utils';

import { useLoginContext } from '@/app/login.context';
import { AUTH0_AUDIENCE } from '@/constants/config.constants';
import { AnalyticEventAction } from '@/services/analytics/analytics.types';
import { trackActionButtonAnalyticsEvent } from '@/services/analytics/analytics-events/action-button-event';
import { trackLoginAnalyticsEvent } from '@/services/analytics/analytics-events/login-event';
import { getIsAutomationClient } from '@/utils/EnvUtils';
import { checkUserRegisteredAfterSsoSucceed } from '@/utils/requests.utils';


const THREE_DAYS_IN_SECONDS = 259_200;

// TODO: THIS ENTIRE FILE TAKEN FROM DASHBOARD AND NEEDS TO BE REFACTORED - EH-6286
const useLoginWithSSO = () => {
  const { setReleaseGroup } = useLoginContext();
  const [errorMessage, setErrorMessage] = useState('');

  const {
    isAuthenticated: isAuthenticatedWithSso,
    getAccessTokenSilently,
    logout,
    loginWithPopup,
    isLoading
  } = useAuth0();

  useEffect(
    function login() {
      const isAutomationClient = getIsAutomationClient();

      if (!isAutomationClient) {
        trackActionButtonAnalyticsEvent({ action: AnalyticEventAction.LoginWithSSO });
      }
      const getUserMetadata = async () => {
        try {
          const accessToken = await getAccessTokenSilently({
            authorizationParams: {
              audience: AUTH0_AUDIENCE,
              scope: 'read:current_user'
            }
          });

          const {clinicianId, ...analyticsMeta} = await checkUserRegisteredAfterSsoSucceed(accessToken);
          setSentryAndAnalyticsAfterLogin(clinicianId, analyticsMeta);
          trackLoginAnalyticsEvent({ action: AnalyticEventAction.SSO, with2FA: false });
          setReleaseGroup(analyticsMeta.releaseGroup);
        } catch (error) {
          // if (
          //   error instanceof HttpError &&
          //   error.name === ErrorName.SSOAuthenticatedButNotRegistered
          // ) {
          //   setErrorMessage(error.ui.title);
          //   logout({ localOnly: true, returnTo: window.location.origin });
          // }
        }
      };

      const shouldTryToAuthenticateAfterSsoSucceed = isAuthenticatedWithSso;
      // &&
      // !userStore.isAuthenticated &&
      // !userStore.isAuthenticatingSession &&
      // !errorMessage;

      if (shouldTryToAuthenticateAfterSsoSucceed) {
        getUserMetadata();
      }
    },
    [getAccessTokenSilently, isAuthenticatedWithSso, logout, errorMessage, setReleaseGroup]
  );

  const clearErrorMessage = () => setErrorMessage('');

  return {
    ssoLoginErrorMessage: errorMessage,
    isAuthenticatedWithSso,
    loginWithSso: Boolean(errorMessage)
      ? () =>
          loginWithPopup(
            {
              /*prompt: 'login'*/
            },
            { timeoutInSeconds: THREE_DAYS_IN_SECONDS }
          )
      : () => loginWithPopup({}, { timeoutInSeconds: THREE_DAYS_IN_SECONDS }),
    isLoginWithSsoLoading: isLoading,
    clearSsoErrorMessage: clearErrorMessage
  };
};

export default useLoginWithSSO;
